export const navLinks = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "Work",
    url: "/work",
  },
  {
    title: "Contact",
    url: "/contact",
  },
  {
    title: "Bracket",
    url: "https://bracket.rawcolorstudios.com/",
    external: true,
  },
  {
    title: "RCPS",
    url: "https://rcps.rawcolorstudios.com/",
    external: true,
  },
];
